/** Public HTML import resource budgets shared by every entry point. */
export const HTML_IMPORT_MAX_BYTES = 5_000_000
/** Worst-case JSON escaping (one byte → `\u0000`) plus envelope headroom. */
export const HTML_IMPORT_MAX_JSON_REQUEST_BYTES =
  HTML_IMPORT_MAX_BYTES * 6 + 1_048_576
export const HTML_IMPORT_MAX_REMOTE_RESOURCES = 256
export const HTML_IMPORT_FETCH_CONCURRENCY = 8
export const HTML_IMPORT_MAX_RESOURCE_BYTES = 10 * 1024 * 1024
export const HTML_IMPORT_MAX_TOTAL_RESOURCE_BYTES = 50 * 1024 * 1024
/**
 * Wall-clock budget for the whole rehost pass (stylesheets + resources).
 * Every fetch is bounded on its own, but 256 resources behind a slow origin
 * still add up to minutes. Past the deadline the remaining resources are
 * RETAINED at their source URL (`fetch_failed_retained`) instead of being
 * fetched, so an import settles inside the dialog's 60 s wait — a later
 * server-side failure could otherwise hide behind the client's abort.
 */
export const HTML_IMPORT_REHOST_BUDGET_MS = 40_000
/** Inline pair budget below Convex's 1 MiB document ceiling. */
export const HTML_IMPORT_MAX_INLINE_REVISION_BYTES = 800_000
/**
 * JSX remains inline so every legacy and streaming reader has a valid editable
 * model. Oversized authoritative HTML is chunked separately at persistence.
 */
export const HTML_IMPORT_MAX_EDITABLE_JSX_BYTES = 700_000

export function htmlImportByteLength(value: string): number {
  return new TextEncoder().encode(value).byteLength
}
/**
 * Inline `data:image` payloads at or below this size stay inline: a 1×1 spacer
 * or the neutralized tracking beacon is 42 bytes, and turning one into a
 * network fetch makes the email worse, not better.
 */
export const HTML_IMPORT_MIN_INLINE_ASSET_BYTES = 64
